import { CersDecisionStatus, StaffCersSubmittalsQuery } from "generated-graphql/graphql";

/** A single CERS submittal row as returned by the staff submittals query. */
export type CersSubmittalRow = StaffCersSubmittalsQuery["staffCersSubmittals"]["items"][number];

/**
 * Color map for CersDecisionStatus chips:
 * Accepted=success, NotAccepted=error, UnderReview/Submitted=info,
 * Certified/NotApplicable=default
 */
export function decisionStatusColor(
  status: CersDecisionStatus
): "success" | "error" | "info" | "default" {
  switch (status) {
    case CersDecisionStatus.Accepted:
      return "success";
    case CersDecisionStatus.NotAccepted:
      return "error";
    case CersDecisionStatus.UnderReview:
    case CersDecisionStatus.Submitted:
      return "info";
    default:
      return "default";
  }
}
